import { Station } from "types/promoType";

interface StationData {
  Radio: Station[];
  Television: Station[];
  Press: Station[];
}

export const StationPlaceHolderData: StationData = {
  Radio: [
    {
      name: "Soundcity",
      location: "Lagos, Nigeria",
      listeners: "1.2M weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "50" },
        { id: "2", name: "3 Airplay", price: "120" }
      ]
    },
    {
      name: "Cool FM",
      location: "Lagos, Nigeria",
      listeners: "980K weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "45" },
        { id: "2", name: "3 Airplay", price: "110" }
      ]
    },
    {
      name: "Wazobia FM",
      location: "Lagos, Nigeria",
      listeners: "850K weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "40" },
        { id: "2", name: "3 Airplay", price: "100" }
      ]
    },
    {
      name: "Beat FM",
      location: "Lagos, Nigeria",
      listeners: "720K weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "35" },
        { id: "2", name: "3 Airplay", price: "90" }
      ]
    },
    {
      name: "Naija FM",
      location: "Abuja, Nigeria",
      listeners: "650K weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "30" },
        { id: "2", name: "3 Airplay", price: "80" }
      ]
    },
    {
      name: "Radio Continental",
      location: "Lagos, Nigeria",
      listeners: "580K weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "28" },
        { id: "2", name: "3 Airplay", price: "75" }
      ]
    },
    {
      name: "Metro FM",
      location: "Johannesburg, South Africa",
      listeners: "1.5M weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "60" },
        { id: "2", name: "3 Airplay", price: "150" }
      ]
    },
    {
      name: "YFM",
      location: "Johannesburg, South Africa",
      listeners: "1.1M weekly listeners",
      type: "Radio",
      packages: [
        { id: "1", name: "1 Airplay", price: "55" },
        { id: "2", name: "3 Airplay", price: "130" }
      ]
    }
  ],
  Television: [
    {
      name: "Channels TV",
      location: "Lagos, Nigeria",
      listeners: "2.5M weekly viewers",
      type: "Tv",
      packages: [
        { id: "1", name: "1 Airplay", price: "80" },
        { id: "2", name: "3 Airplay", price: "200" }
      ]
    },
    {
      name: "NTA",
      location: "Abuja, Nigeria",
      listeners: "1.8M weekly viewers",
      type: "Tv",
      packages: [
        { id: "1", name: "1 Airplay", price: "70" },
        { id: "2", name: "3 Airplay", price: "180" }
      ]
    }
  ],
  Press: [
    {
      name: "Pulse Nigeria",
      location: "Lagos, Nigeria",
      listeners: "500K monthly readers",
      type: "Press",
      packages: [
        { id: "1", name: "1 Article", price: "100" },
        { id: "2", name: "3 Articles", price: "250" }
      ]
    },
    {
      name: "BellaNaija",
      location: "Lagos, Nigeria",
      listeners: "800K monthly readers",
      type: "Press",
      packages: [
        { id: "1", name: "1 Article", price: "120" },
        { id: "2", name: "3 Articles", price: "300" }
      ]
    }
  ]
};
